import {useEntityApi} from '../use-entity-api';
import {Genre} from '../../api/DTOs/Genre';

export function useGenresApi() {
  return useEntityApi<Genre>({prefixUrl: 'genres', isAdmin: false});
}
